import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface QuestDto {
	id: string;
	worldId: string;
	name: string;
	description: string | null;
	gmNotes: string | null;
	status: string;
	factionId: string | null;
	factionName: string | null;
	npcId: string | null;
	npcName: string | null;
	godId: string | null;
	godName: string | null;
	imageAssetId: string | null;
	mapAssetId: string | null;
	pdfAssetId: string | null;
	foundryId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface QuestsListResponse {
	quests: QuestDto[];
	total: number;
}

export interface QuestGetResponse {
	quest: QuestDto;
}

export interface UpsertQuestRequest {
	name: string;
	description?: string | null;
	gmNotes?: string | null;
	status?: string | null;
	factionId?: string | null;
	npcId?: string | null;
	godId?: string | null;
	foundryId?: string | null;
	imageAssetId?: string | null;
	mapAssetId?: string | null;
	pdfAssetId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class QuestsService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, q?: string): Observable<QuestsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (q) params = params.set('q', q);
		return this.http.get<QuestsListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/quests`, { params });
	}

	get(worldId: string, questId: string): Observable<QuestGetResponse> {
		return this.http.get<QuestGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/quests/${questId}`);
	}

	create(worldId: string, request: UpsertQuestRequest): Observable<QuestGetResponse> {
		return this.http.post<QuestGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/quests`, {
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			Status: request.status ?? null,
			FactionId: request.factionId ?? null,
			NpcId: request.npcId ?? null,
			GodId: request.godId ?? null,
			FoundryId: request.foundryId ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
		});
	}

	update(worldId: string, questId: string, request: UpsertQuestRequest): Observable<QuestGetResponse> {
		return this.http.put<QuestGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/quests/${questId}`, {
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			Status: request.status ?? null,
			FactionId: request.factionId ?? null,
			NpcId: request.npcId ?? null,
			GodId: request.godId ?? null,
			FoundryId: request.foundryId ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
		});
	}

	delete(worldId: string, questId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/quests/${questId}`);
	}
}
